import { Button, Tooltip } from "antd"
import { UpOutlined } from "@ant-design/icons"
import React from "react"
import { useIntl } from "react-intl"

type Props = {
  onMoveUp?: () => void
  disabled?: boolean
}

export const MoveUpButton = ({ onMoveUp, disabled }: Props) => {
  const intl = useIntl()

  return (
    <Tooltip placement="top" title={intl.formatMessage({ id: "common.moveUp" })}>
      <Button
        type="dashed"
        shape="circle"
        icon={<UpOutlined />}
        onClick={() => onMoveUp?.()}
        disabled={disabled}
      />
    </Tooltip>
  )
}
